import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'

export const useNotifications = defineStore('notificationsStore', () => {
    const isShowNotification = ref(false)
    const notifications = ref()
    const fetcher = useCustomFetch()

    const hasNotificationUnread = computed(() => {
        if (!notifications.value?.length) return false
        return notifications.value?.some((item) => !item.is_readed)
    })

    const updateNotificationStatus = async (payload) => {
        await fetcher.post('/notification/read', payload)
    }

    const handleReadAll = () => {
        for (let i = 0; i < notifications.value.length; i++) {
            if (!notifications.value[i].is_readed) {
                const formData = {
                    id: notifications.value[i].id,
                    type: notifications.value[i].type,
                }
                updateNotificationStatus(formData)
            }
        }

        // Clone the notifications array and update the is_readed property
        notifications.value = notifications.value.map((item) => {
            return {
                ...item,
                is_readed: true,
            }
        })
    }

    const markAsRead = ({ id, type }) => {
        updateNotificationStatus({ id, type })

        // Clone the notifications array and update the is_readed property
        notifications.value = notifications.value.map((item) => {
            if (item.id === id) {
                return {
                    ...item,
                    is_readed: true,
                }
            }
            return item
        })
    }

    return {
        notifications,
        hasNotificationUnread,
        updateNotificationStatus,
        markAsRead,
        handleReadAll,
        isShowNotification,
    }
})
